import "./InfoLine.css";

function InfoLine({ }) {
    const INFO = [
        {
            title: `Доставка`,
            text: `Доставка в течении нескольких дней, возможна международная доставка`,
        },
        {
            title: `Оплата`,
            text: `Оплата наличными (USD, RUB, AED) или криптовалютой. Все цены указаны в USD по курсу 1:1 с USDT`,
        },
        {
            title: `Проверка подлинности`,
            text: `Дополнительная проверка подлинности и сертификация доступны по запросу`,
        },
    ];
    return (
        <div className={`info-line`}>
            {INFO.map((item) => {
                return (
                    <div className="info-line__item">
                        <p className="info-line__item__title">{item.title}</p>
                        <p className="info-line__item__text" dangerouslySetInnerHTML={{
                            __html: item.text
                        }}></p>
                    </div>
                )
            })}
        </div>
    );
}

export default InfoLine;